'use strict';

(function (Drupal) {

  /**
   * AJAX start / complete replacements.
   * Drupal triggers a global event: "ajaxStart" and "ajaxComplete"
   * via Drupal.Ajax.
   */
  document.addEventListener('ajaxStart', function () {
    const submit = document.querySelector('#edit-submit');
    if (submit) {
      submit.style.display = 'none';
    }
  });

  document.addEventListener('ajaxComplete', function () {
    const submit = document.querySelector('#edit-submit');
    if (submit) {
      submit.style.display = '';
    }
  });

  /**
   * Prevent ENTER key from submitting the form
   */
  function preventEnterSubmit(inputSelector) {
    const input = document.querySelector(inputSelector);
    if (!input) return;

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        console.log('disabled enter submit');
        event.preventDefault();
      }
    });
  }

  preventEnterSubmit('#edit-course-register-lidnr');
  preventEnterSubmit('#edit-course-discount-code');

})(Drupal);
